<template>
  <svg :height="height" :width="width">
    <text v-if="upperDot" :x="width*0.1" :y="height*0.1" :font-size="2" fill="red">.</text>
    <line v-if="isBar == true" x1="width*0.3" :y1="height*0.5" :x2="width*0.7" :y2="height*0.5" style="stroke:rgb(0,0,0);stroke-width:1" />
    <text v-else :x="width*0.2" :y="height*0.8" :font-size="width" fill="blue">{{noteName}}</text>
  </svg>
</template>

<script>
export default {
  name: 'Note',
  props: {
    width: Number,
    height: Number,
    noteName: Number,
    duration: String,
    upperDot: Boolean,
    underLines: Number,
    isBar: Boolean
  }
}
</script>
